/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, useRef, useEffect } from "react";
import { Ellipsis, LogOut, X } from "lucide-react";
import { cn } from "lib/utils";
import { getMenuList } from "lib/menus";
import { ScrollArea } from "components/ui/scroll-area";
import {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
  TooltipProvider,
} from "components/ui/tooltip";
import { useConfig } from "hooks/use-config";
import MenuLabel from "../common/menu-label";
import MenuItem from "../common/menu-item";
import { CollapseMenuButton } from "../common/collapse-menu-button";
// import MenuWidget from "../common/menu-widget";
import Logo from "components/logo";
import SidebarHoverToggle from "components/partials/sidebar/sidebar-hover-toggle";
import { useMenuHoverConfig } from "hooks/use-menu-hover";
import { useMediaQuery } from "hooks/use-media-query";

// eslint-disable-next-line no-empty-pattern
export function MenuClassic({}) {
  // Removed translations hook and used plain strings where necessary

  // Removed pathname and params; handle routing or state differently based on your needs
  // const pathname = usePathname();
  // const params = useParams<{ locale: string; }>();

  const isDesktop = useMediaQuery("(min-width: 1280px)");
  const [config, setConfig] = useConfig();
  const collapsed = config.collapsed;
  const [hoverConfig] = useMenuHoverConfig();
  const { hovered } = hoverConfig;

  const scrollableNodeRef = useRef<HTMLDivElement>(null);
  const [scroll, setScroll] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (
        scrollableNodeRef.current &&
        scrollableNodeRef.current.scrollTop > 0
      ) {
        setScroll(true);
      } else {
        setScroll(false);
      }
    };
    scrollableNodeRef.current?.addEventListener("scroll", handleScroll);
  }, [scrollableNodeRef]);

  // Dummy data for menu list, you can fetch or create your own
  const pathname = window.location.pathname; // Placeholder for the current path
  const menuList = getMenuList(pathname); // Replace with your own menu data

  return (
    <>
      <div
        className={cn("flex h-16 flex-none items-center justify-between gap-2 px-5", {
          "lg:justify-center lg:px-0": collapsed && !hovered,
        })}
      >
        <Logo />
        <SidebarHoverToggle />
        <button
          type="button"
          onClick={() => setConfig({ ...config, menuHidden: true })}
          className="lg:hidden -me-2 flex h-9 w-9 items-center justify-center rounded-full text-default-600 transition-colors hover:bg-default-100 hover:text-default-900"
          aria-label="Close menu"
        >
          <X className="h-5 w-5" />
        </button>
      </div>

      <ScrollArea className="min-h-0 flex-1 [&>div>div[style]]:!block">
        <nav className="w-full pb-8 pt-2">
          <ul className="flex flex-col items-start space-y-1 px-3">
            {menuList?.map(({ groupLabel, menus }, index) => (
              <li className={cn("w-full", groupLabel ? "" : "")} key={index}>
                {(!collapsed || hovered) && groupLabel ? (
                  <MenuLabel label={groupLabel} />
                ) : collapsed && !hovered && groupLabel ? (
                  <TooltipProvider>
                    <Tooltip delayDuration={100}>
                      <TooltipTrigger className="w-full">
                        <div className="w-full flex justify-center items-center">
                          <Ellipsis className="h-5 w-5 text-default-700" />
                        </div>
                      </TooltipTrigger>
                      <TooltipContent side="right">
                        <p>{groupLabel}</p>
                      </TooltipContent>
                    </Tooltip>
                  </TooltipProvider>
                ) : null}

                {menus.map(
                  (
                    { href, label, icon, active, id, submenus, badge },
                    index,
                  ) =>
                    submenus.length === 0 ? (
                      <div className="w-full mb-2 last:mb-0" key={index}>
                        <TooltipProvider disableHoverableContent>
                          <Tooltip delayDuration={100}>
                            <TooltipTrigger asChild>
                              <div>
                                <MenuItem
                                  label={label}
                                  icon={icon}
                                  href={href}
                                  active={active}
                                  id={id}
                                  collapsed={collapsed}
                                  badge={badge}
                                />
                              </div>
                            </TooltipTrigger>
                            {collapsed && (
                              <TooltipContent side="right">
                                {label}
                              </TooltipContent>
                            )}
                          </Tooltip>
                        </TooltipProvider>
                      </div>
                    ) : (
                      <div className="w-full mb-2" key={index}>
                        <CollapseMenuButton
                          icon={icon}
                          label={label}
                          active={active}
                          submenus={submenus}
                          collapsed={collapsed}
                          id={id}
                        />
                      </div>
                    ),
                )}
              </li>
            ))}
            {/*{!collapsed && (*/}
            {/*    <li className="w-full grow flex items-end">*/}
            {/*        <MenuWidget />*/}
            {/*    </li>*/}
            {/*)}*/}
          </ul>
        </nav>
      </ScrollArea>
    </>
  );
}
